import { ReactElement } from 'react'

export function OverrideConfirmation(): ReactElement {
  return (
    <div className="flex animate-fade-left flex-col gap-y-6 animate-duration-[400ms] md:grow md:items-center md:justify-center md:px-14">
      <span className="text-heading-xl text-strong">Thank you</span>
      <p className="text-body-md font-medium text-default md:px-2 md:text-center">
        Your request has been submitted. Our office will reach out to schedule your appointment shortly.
      </p>
    </div>
  )
}
